import { LeaderboardRankResponseObject } from '@wwe-portal/entities/rbe.type';
import {
  createPortableDialog,
  Dialog,
  DialogCloseButton,
  DialogContent,
  usePortableDialog,
} from '../../../../../packages/ui/components/dialog';
import React from 'react';

import { LeaderboardRewards } from './leaderboard-rewards';
import { RewardRankContainer } from './leaderboard-reward-item';
import { EventEndedBanner } from './event-ended-banner';

export const LeaderboardRewardsDialog = createPortableDialog(
  ({
    brackets,
    currentPlayerRank,
    endDate,
  }: {
    brackets: Partial<LeaderboardRankResponseObject>['brackets'];
    currentPlayerRank: number;
    endDate: string;
  }) => {
    const modal = usePortableDialog();
    return (
      <Dialog
        open={modal.visible}
        onOpenChange={(value) => {
          if (!value) {
            modal.remove();
          }
        }}
      >
        <DialogContent
          variant="message"
          className="from-back400 to-back400 bg-back400 px-4 pb-10 pt-5 md:max-w-[650px] lg:max-w-[650px] xl:max-w-[650px] 2xl:max-w-[650px]"
        >
          <div className="flex flex-col items-stretch gap-5 overflow-visible">
            <div className="text-text300 text-center text-sm">
              Leaderboard Rewards
            </div>
            <div className="text-text500 text-center text-xs">
              Rewards are automatically sent directly to your in-game inbox
              after an event has concluded
            </div>
            <EventEndedBanner className="-mx-4" event={{ endDate }} />
            <div className="scrollbar-moz max-h-[380px] overflow-y-auto">
              <div className="flex flex-col items-stretch">
                {brackets?.map((bracket) => {
                  const getBrackRankText = (startValue, endValue) => {
                    if (startValue === endValue) return `Rank ${startValue}`;
                    return `Rank ${startValue}-${endValue}`;
                  };
                  const bracketRankText = getBrackRankText(
                    bracket.rewardRankStartValue,
                    bracket.rewardRankEndValue
                  );
                  const isCurrentPlayerBracket =
                    currentPlayerRank &&
                    bracket?.rewardRankStartValue != null &&
                    bracket?.rewardRankEndValue != null &&
                    currentPlayerRank >= bracket?.rewardRankStartValue &&
                    currentPlayerRank <= bracket?.rewardRankEndValue;

                  const rewards = [...(bracket?.rewards ?? [])];
                  rewards.sort(
                    (a, b) => (a.rewardWeight ?? 0) - (b.rewardWeight ?? 0)
                  );
                  return (
                    <RewardRankContainer
                      key={`${bracket.rewardRankStartValue}-${bracket.rewardRankEndValue}`}
                      rank={bracketRankText}
                      highlight={!!isCurrentPlayerBracket}
                      rankInfoElement={
                        isCurrentPlayerBracket ? (
                          <>
                            Your
                            <br />
                            {`Rank: ${currentPlayerRank}`}
                          </>
                        ) : undefined
                      }
                      rewardsElement={<LeaderboardRewards rewards={rewards} />}
                    />
                  );
                })}
              </div>
            </div>
          </div>
          <DialogCloseButton onClose={() => modal.remove()} />
        </DialogContent>
      </Dialog>
    );
  }
);
